interface HTMLSpanElementWithTimeout extends HTMLSpanElement {
    timeoutId?: number;
}

export const removeToast = (toast: HTMLSpanElementWithTimeout) => {
    toast.classList.add('hide')
    if (toast.timeoutId) clearTimeout(toast.timeoutId)
    setTimeout(() => {
        toast.remove()
    }, 500)
}